export function randomArray(arr: Array<any>): Array<any> {
    return arr.sort(() => Math.random() - 0.5);
}
